import { render, staticRenderFns } from "./WizardSystemRequirementStep.vue?vue&type=template&id=5ae7e484&"
import script from "./WizardSystemRequirementStep.vue?vue&type=script&lang=js&"
export * from "./WizardSystemRequirementStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae7e484')) {
      api.createRecord('5ae7e484', component.options)
    } else {
      api.reload('5ae7e484', component.options)
    }
    module.hot.accept("./WizardSystemRequirementStep.vue?vue&type=template&id=5ae7e484&", function () {
      api.rerender('5ae7e484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/WizardSystemRequirementStep.vue"
export default component.exports